export default __webpack_public_path__ + "static/media/Etherfishing_Lounge_Theme.75f91dbd.wav";